module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-cerita-01.edd55ff0.jpg";